// V71.36 — Arayan ekranı: santral cebinizi çaldırırken arayanın kartı (rehber, yolcu, önceki aramalar, WhatsApp, rezervasyon)
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import { useAuth } from '../context/AuthContext';
import { santralAPI, rehberAPI } from '../services/api';
import './SantralCagriKarti.css';

const DURUM = { caliyor: 'Çalıyor', gorusmede: 'Görüşmede', gecti: 'Sıradakine geçti', bitti: 'Görüşme bitti' };
const SONUC = { cevaplandi: 'cevaplandı', sesli_mesaj: 'sesli mesaj', kapatti: 'cevapsız', menude: 'menüde kapattı' };

const tarih = (v) => {
  if (!v) return null;
  const s = String(v);
  const d = new Date(/[TZ]/.test(s) ? s : `${s.replace(' ', 'T')}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
};
const once = (v) => {
  const d = tarih(v);
  if (!d) return '';
  const dk = Math.round((Date.now() - d.getTime()) / 60000);
  if (dk < 1) return 'az önce';
  if (dk < 60) return `${dk} dk önce`;
  if (dk < 24 * 60) return `${Math.round(dk / 60)} sa önce`;
  if (dk < 7 * 24 * 60) return `${Math.round(dk / 1440)} gün önce`;
  return d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: '2-digit' });
};
const sure = (sn) => `${Math.floor(sn / 60)}:${String(Math.max(0, sn) % 60).padStart(2, '0')}`;
const numara = (n) => {
  const d = String(n || '').replace(/\D/g, '');
  const t = d.replace(/^90(?=\d{10}$)/, '').replace(/^0(?=\d{10}$)/, '');
  return /^\d{10}$/.test(t) ? `0${t.slice(0, 3)} ${t.slice(3, 6)} ${t.slice(6, 8)} ${t.slice(8)}` : d ? `+${d}` : 'Numara gizli';
};

function Kart({ k, simdi, kapat, rehbereEklendi }) {
  const navigate = useNavigate();
  const [ekle, setEkle] = useState(null);
  const [hata, setHata] = useState('');
  const git = (yol) => { navigate(yol); };
  const gecen = k.durum === 'gorusmede' && k.acildi ? sure(Math.round((simdi - k.acildi) / 1000))
    : k.durum === 'caliyor' ? sure(Math.round((simdi - k.alindi) / 1000))
      : k.durum === 'bitti' && k.konusma != null ? sure(k.konusma) : '';
  const bos = !k.ad && !k.cagri?.toplam && !k.whatsapp && !k.rezervasyonlar?.length && !k.yolcular?.length;

  const kaydet = async (e) => {
    e.preventDefault();
    if (!ekle.ad.trim()) return;
    setHata('');
    try {
      const r = await rehberAPI.add([{ no: k.arayan, ad: ekle.ad.trim(), firma: ekle.firma.trim() }]);
      if (r.data?.hataliSayi) { setHata(r.data.hatali?.[0]?.neden || 'Eklenemedi'); return; }
      rehbereEklendi(k.id, ekle.ad.trim(), ekle.firma.trim());
      setEkle(null);
    } catch (err) { setHata(err.response?.data?.error || 'Eklenemedi'); }
  };

  return (
    <div className={`sck sck--${k.durum}`}>
      <div className="sck-ust">
        <span className="sck-durum"><i />{DURUM[k.durum] || k.durum}</span>
        {k.kuyruk && <span className="sck-hat">{k.kuyruk}</span>}
        {gecen && <span className="sck-sure">{gecen}</span>}
        <button type="button" className="sck-x" onClick={() => kapat(k.id)} aria-label="Kartı kapat">×</button>
      </div>
      <div className="sck-kim">
        <div className="sck-ad">{k.ad || numara(k.arayan)}</div>
        <div className="sck-alt">{[k.firma, k.ad ? numara(k.arayan) : null].filter(Boolean).join(' · ')}</div>
        {k.yonlendiren && <div className="sck-yon">↪ {k.yonlendiren} cebinden yönlendirildi</div>}
      </div>

      <div className="sck-bilgi">
        {bos && <div className="sck-satir sck-soluk">Bu numarayla ilgili kayıt yok — ilk kez arıyor olabilir.</div>}
        {k.cagri?.toplam > 0 && (
          <div className="sck-satir">
            <span className="sck-ik" aria-hidden>📞</span>
            <span>{k.cagri.toplam} önceki arama · son {once(k.cagri.son[0]?.basla_at)}, {SONUC[k.cagri.son[0]?.sonuc] || k.cagri.son[0]?.sonuc}{k.cagri.son[0]?.acan ? ` (${k.cagri.son[0].acan})` : ''}</span>
          </div>
        )}
        {k.whatsapp && (
          <button type="button" className="sck-satir sck-link" onClick={() => git(k.whatsapp.conv_id ? `/whatsapp?c=${k.whatsapp.conv_id}` : '/whatsapp')}>
            <span className="sck-ik" aria-hidden>💬</span>
            <span>
              WhatsApp{k.whatsapp.durum ? ` · ${k.whatsapp.durum}` : ''}{k.whatsapp.son_at ? ` · ${once(k.whatsapp.son_at)}` : ''}{k.whatsapp.atanan ? ` · ${k.whatsapp.atanan}` : ''}
              {k.whatsapp.onizleme && <em>“{k.whatsapp.onizleme}”</em>}
            </span>
          </button>
        )}
        {k.rezervasyonlar?.map(r => (
          <button type="button" key={r.id} className="sck-satir sck-link" onClick={() => git('/rezervasyonlar')}>
            <span className="sck-ik" aria-hidden>✈️</span>
            <span>{[r.referans, r.rota, r.dep_date, r.durum].filter(Boolean).join(' · ')}{r.opsiyon_at ? ` · opsiyon ${tarih(r.opsiyon_at)?.toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) || r.opsiyon_at}` : ''}</span>
          </button>
        ))}
        {k.yolcular?.map(y => (
          <button type="button" key={y.id} className="sck-satir sck-link" onClick={() => git(`/customers?search=${encodeURIComponent(y.ad)}`)}>
            <span className="sck-ik" aria-hidden>👤</span>
            <span>Yolcu kaydı: {y.ad}{y.firma ? ` (${y.firma})` : ''}</span>
          </button>
        ))}
      </div>

      {!k.rehberde && k.arayan && (ekle ? (
        <form className="sck-ekle" onSubmit={kaydet}>
          <input autoFocus placeholder="Ad Soyad" value={ekle.ad} maxLength={80} onChange={e => setEkle({ ...ekle, ad: e.target.value })} />
          <input placeholder="Firma (isteğe bağlı)" value={ekle.firma} maxLength={80} onChange={e => setEkle({ ...ekle, firma: e.target.value })} />
          <div className="sck-ekle-alt">
            {hata && <span className="sck-hata">{hata}</span>}
            <button type="button" className="sck-btn sck-btn--soluk" onClick={() => { setEkle(null); setHata(''); }}>Vazgeç</button>
            <button type="submit" className="sck-btn" disabled={!ekle.ad.trim()}>Kaydet</button>
          </div>
        </form>
      ) : (
        <button type="button" className="sck-btn sck-btn--soluk sck-ekle-ac" onClick={() => setEkle({ ad: k.ad || '', firma: k.firma || '' })}>+ Rehberime ekle</button>
      ))}
    </div>
  );
}

export default function SantralCagriKarti() {
  const { user } = useAuth();
  const uid = user?.id;
  const [kartlar, setKartlar] = useState([]);
  const [simdi, setSimdi] = useState(Date.now());
  const sokRef = useRef(null);

  useEffect(() => {
    if (!uid) return undefined;
    let iptal = false;
    const ekle = (k) => setKartlar(prev => {
      const eski = prev.find(x => x.id === k.id);
      const yeni = { ...k, alindi: eski?.durum === k.durum ? eski.alindi : Date.now(), guncel: Date.now() };
      return [yeni, ...prev.filter(x => x.id !== k.id)].slice(0, 3);
    });
    santralAPI.canli().then(r => {
      if (iptal || !r.data?.uye) return;
      (r.data.cagrilar || []).forEach(ekle);
      const SOCKET_URL = (process.env.REACT_APP_API_URL || window.location.origin).replace(/\/api$/, '');
      sokRef.current = io(SOCKET_URL, {
        auth: (cb) => { let t = null; try { t = localStorage.getItem('mtu_token'); } catch {} cb({ token: t }); },
        transports: ['polling'],
        upgrade: false,
        reconnectionAttempts: 10,
        reconnectionDelay: 2000,
        reconnectionDelayMax: 30000,
      });
      sokRef.current.on('santral:cagri', ekle);
      sokRef.current.on('santral:kapat', ({ id }) => setKartlar(prev => prev.filter(x => x.id !== id)));
    }).catch(() => {});
    return () => { iptal = true; sokRef.current?.disconnect(); sokRef.current = null; };
  }, [uid]);

  // Saniye sayacı + kendiliğinden kapanma: sıradakine geçen 8 sn, haber gelmeyen "çalıyor" 90 sn sonra
  const var_ = kartlar.length > 0;
  useEffect(() => {
    if (!var_) return undefined;
    const t = setInterval(() => {
      const n = Date.now();
      setSimdi(n);
      setKartlar(prev => {
        const kalan = prev.filter(k => !(k.durum === 'gecti' && n - k.guncel > 8000) && !(k.durum === 'caliyor' && n - k.guncel > 90000));
        return kalan.length === prev.length ? prev : kalan;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [var_]);

  if (!var_) return null;
  const kapat = (id) => setKartlar(prev => prev.filter(x => x.id !== id));
  const rehbereEklendi = (id, ad, firma) => setKartlar(prev => prev.map(x => (x.id === id ? { ...x, ad, firma: firma || x.firma, rehberde: true } : x)));
  return createPortal(
    <div className="sck-yigin" role="status" aria-live="polite">
      {kartlar.map(k => <Kart key={k.id} k={k} simdi={simdi} kapat={kapat} rehbereEklendi={rehbereEklendi} />)}
    </div>,
    document.body,
  );
}
